/* eslint-disable */
/* eslint-enable prettier/prettier */

import aloomaTruncate from '@rover/shared/js/eventstream/aloomaTruncate';

const { userAgent } = navigator;

export const createUUID = (function () {
  // Time/ticks information
  // 1*new Date() is a cross browser version of Date.now()
  const T = function () {
    const d = 1 * new Date();
    let i = 0;

    // this while loop figures how many browser ticks go by
    // before 1*new Date() returns a new number, ie the amount
    // of ticks that go by per millisecond
    while (d == 1 * new Date()) {
      i++;
    }

    return d.toString(16) + i.toString(16);
  };

  // Math.Random entropy
  const R = function () {
    return Math.random().toString(16).replace('.', '');
  };

  // User agent entropy
  // This function takes the user agent string, and then xors
  // together each sequence of 8 bytes.  This produces a final
  // sequence of 8 bytes which it returns as hex.
  const UA = function () {
    const ua = userAgent;
    let i;
    let ch;
    let buffer = [];
    let ret = 0;

    function xor(result, byte_array) {
      let j;
      let tmp = 0;
      for (j = 0; j < byte_array.length; j++) {
        tmp |= buffer[j] << (j * 8);
      }
      return result ^ tmp;
    }

    for (i = 0; i < ua.length; i++) {
      ch = ua.charCodeAt(i);
      buffer.unshift(ch & 0xff);
      if (buffer.length >= 4) {
        ret = xor(ret, buffer);
        buffer = [];
      }
    }

    if (buffer.length > 0) {
      ret = xor(ret, buffer);
    }

    return ret.toString(16);
  };

  return function () {
    const se = (screen.height * screen.width).toString(16);
    return `${T()}-${R()}-${UA()}-${se}-${T()}`;
  };
})();

export default function (instanceName = 'alooma') {
  /*
   * Alooma JS Library
   *
   * Copyright 2012, Alooma, Inc. All Rights Reserved
   * http://alooma.com/
   *
   * Includes portions of Underscore.js
   * http://documentcloud.github.com/underscore/
   * (c) 2011 Jeremy Ashkenas, DocumentCloud Inc.
   * Released under the MIT License.
   */

  // ==ClosureCompiler==
  // @compilation_level ADVANCED_OPTIMIZATIONS
  // @output_file_name alooma-2.7.min.js
  // ==/ClosureCompiler==

  /*
      SIMPLE STYLE GUIDE:
      this.x == public function
      this._x == internal - only use within this file
      this.__x == private - only use within the class
      Globals should be all caps
      */

  const LIB_VERSION = '1.0.0';

  let init_type; // MODULE or SNIPPET loader
  let alooma_master; // main alooma instance / object
  const INIT_MODULE = 0;
  const INIT_SNIPPET = 1;

  /*
   * Saved references to long variable names, so that closure compiler can
   * minimize file size.
   */
  const ArrayProto = Array.prototype;
  const FuncProto = Function.prototype;
  const ObjProto = Object.prototype;
  const { slice } = ArrayProto;
  const { toString } = ObjProto;
  const { hasOwnProperty } = ObjProto;
  const windowConsole = window.console;
  const { navigator } = window;
  const { document } = window;

  /*
   * Constants
   */
  /** @const */ const PRIMARY_INSTANCE_NAME = instanceName;
  /** @const */ const SET_QUEUE_KEY = '__mps';
  /** @const */ const SET_ONCE_QUEUE_KEY = '__mpso';
  /** @const */ const ADD_QUEUE_KEY = '__mpa';
  /** @const */ const APPEND_QUEUE_KEY = '__mpap';
  /** @const */ const UNION_QUEUE_KEY = '__mpu';
  /** @const */ const SET_ACTION = '$set';
  /** @const */ const SET_ONCE_ACTION = '$set_once';
  /** @const */ const ADD_ACTION = '$add';
  /** @const */ const APPEND_ACTION = '$append';
  /** @const */ const UNION_ACTION = '$union';
  // This key is deprecated, but we want to check for it to see whether aliasing is allowed.
  /** @const */ const PEOPLE_DISTINCT_ID_KEY = '$people_distinct_id';
  /** @const */ const ALIAS_ID_KEY = '__alias';
  /** @const */ const CAMPAIGN_IDS_KEY = '__cmpns';
  /** @const */ const EVENT_TIMERS_KEY = '__timers';
  /** @const */ const RESERVED_PROPERTIES = [
    SET_QUEUE_KEY,
    SET_ONCE_QUEUE_KEY,
    ADD_QUEUE_KEY,
    APPEND_QUEUE_KEY,
    UNION_QUEUE_KEY,
    PEOPLE_DISTINCT_ID_KEY,
    ALIAS_ID_KEY,
    CAMPAIGN_IDS_KEY,
    EVENT_TIMERS_KEY,
  ];

  /*
   * Dynamic... constants? Is that an oxymoron?
   */
  const HTTP_PROTOCOL = document.location.protocol == 'https:' ? 'https://' : 'http://';
  // http://hacks.mozilla.org/2009/07/cross-site-xmlhttprequest-with-cors/
  // https://developer.mozilla.org/en-US/docs/DOM/XMLHttpRequest#withCredentials
  const USE_XHR = window.XMLHttpRequest && 'withCredentials' in new XMLHttpRequest();
  // IE<10 does not support cross-origin XHR's but script tags
  // with defer won't block window.onload; ENQUEUE_REQUESTS
  // should only be true for Opera<12
  let ENQUEUE_REQUESTS =
    !USE_XHR && userAgent.indexOf('MSIE') == -1 && userAgent.indexOf('Mozilla') == -1;

  /*
   * Module-level globals
   */
  const _ = {};
  let DEBUG = false;
  const DEFAULT_CONFIG = {
    api_host: `${HTTP_PROTOCOL}inputs.alooma.com`,
    api_method: 'GET',
    api_transport: 'XHR',
    xhr_headers: {},
    cross_subdomain_cookie: true,
    persistence: 'cookie',
    persistence_name: '',
    cookie_name: '',
    loaded() {},
    store_google: true,
    save_referrer: true,
    test: false,
    verbose: false,
    img: false,
    track_pageview: true,
    debug: false,
    track_links_timeout: 300,
    cookie_expiration: 365,
    upgrade: false,
    disable_persistence: false,
    disable_cookie: false,
    secure_cookie: false,
    ip: true,
    property_blacklist: [],
    truncate: 255,
  };
  let DOM_LOADED = false;

  // UNDERSCORE
  // Embed part of the Underscore Library

  (function () {
    const nativeBind = FuncProto.bind;
    const nativeForEach = ArrayProto.forEach;
    const nativeIndexOf = ArrayProto.indexOf;
    const nativeIsArray = Array.isArray;
    const breaker = {};

    const ctor = function () {};

    _.bind = function (func, context) {
      let args;
      let bound;
      if (nativeBind && func.bind === nativeBind)
        return nativeBind.apply(func, slice.call(arguments, 1));
      if (!_.isFunction(func)) throw new TypeError();
      args = slice.call(arguments, 2);
      return (bound = function () {
        if (!(this instanceof bound))
          return func.apply(context, args.concat(slice.call(arguments)));
        ctor.prototype = func.prototype;
        const self = new ctor();
        ctor.prototype = null;
        const result = func.apply(self, args.concat(slice.call(arguments)));
        if (Object(result) === result) return result;
        return self;
      });
    };

    _.bind_instance_methods = function (obj) {
      for (const func in obj) {
        if (typeof obj[func] === 'function') {
          obj[func] = _.bind(obj[func], obj);
        }
      }
    };

    /**
     * @param {Object=} obj
     * @param {function(...)=} iterator
     * @param {Object=} context
     */
    const each = (_.each = function (obj, iterator, context) {
      if (obj == null) return;
      if (nativeForEach && obj.forEach === nativeForEach) {
        obj.forEach(iterator, context);
      } else if (obj.length === +obj.length) {
        for (let i = 0, l = obj.length; i < l; i++) {
          if (i in obj && iterator.call(context, obj[i], i, obj) === breaker) return;
        }
      } else {
        for (const key in obj) {
          if (hasOwnProperty.call(obj, key)) {
            if (iterator.call(context, obj[key], key, obj) === breaker) return;
          }
        }
      }
    });

    _.escapeHTML = function (s) {
      let escaped = s;
      if (escaped && _.isString(escaped)) {
        escaped = escaped
          .replace(/&/g, '&amp;')
          .replace(/</g, '&lt;')
          .replace(/>/g, '&gt;')
          .replace(/"/g, '&quot;')
          .replace(/'/g, '&#039;');
      }
      return escaped;
    };

    /**
     * @type {function(Object, ...*):Object}
     */
    _.extend = function (obj) {
      each(slice.call(arguments, 1), function (source) {
        for (const prop in source) {
          if (source[prop] !== void 0) obj[prop] = source[prop];
        }
      });
      return obj;
    };

    _.isArray =
      nativeIsArray ||
      function (obj) {
        return toString.call(obj) === '[object Array]';
      };

    // from a comment on http://dbj.org/dbj/?p=286
    // fails on only one very rare and deliberate custom object:
    // var bomb = { toString : undefined, valueOf: function(o) { return "function BOMBA!"; }};
    _.isFunction = function (f) {
      try {
        return /^\s*\bfunction\b/.test(f);
      } catch (x) {
        return false;
      }
    };

    _.isArguments = function (obj) {
      return !!(obj && hasOwnProperty.call(obj, 'callee'));
    };

    _.toArray = function (iterable) {
      if (!iterable) return [];
      if (iterable.toArray) return iterable.toArray();
      if (_.isArray(iterable)) return slice.call(iterable);
      if (_.isArguments(iterable)) return slice.call(iterable);
      return _.values(iterable);
    };

    _.values = function (obj) {
      const results = [];
      if (obj == null) return results;
      each(obj, function (value) {
        results[results.length] = value;
      });
      return results;
    };

    _.identity = function (value) {
      return value;
    };

    _.include = function (obj, target) {
      let found = false;
      if (obj == null) return found;
      if (nativeIndexOf && obj.indexOf === nativeIndexOf) return obj.indexOf(target) != -1;
      each(obj, function (value) {
        if (found || (found = value === target)) {
          return breaker;
        }
      });
      return found;
    };

    _.includes = function (str, needle) {
      return str.indexOf(needle) !== -1;
    };
  })();

  // Underscore Addons
  _.inherit = function (subclass, superclass) {
    subclass.prototype = new superclass();
    subclass.prototype.constructor = subclass;
    subclass.superclass = superclass.prototype;
    return subclass;
  };

  _.isObject = function (obj) {
    return obj === Object(obj) && !_.isArray(obj);
  };

  _.isEmptyObject = function (obj) {
    if (_.isObject(obj)) {
      for (const key in obj) {
        if (hasOwnProperty.call(obj, key)) {
          return false;
        }
      }
      return true;
    }
    return false;
  };

  _.isUndefined = function (obj) {
    return obj === void 0;
  };

  _.isString = function (obj) {
    return toString.call(obj) == '[object String]';
  };

  _.isDate = function (obj) {
    return toString.call(obj) == '[object Date]';
  };

  _.isNumber = function (obj) {
    return toString.call(obj) == '[object Number]';
  };

  _.encodeDates = function (obj) {
    _.each(obj, function (v, k) {
      if (_.isDate(v)) {
        obj[k] = _.formatDate(v);
      } else if (_.isObject(v)) {
        obj[k] = _.encodeDates(v); // recurse
      }
    });
    return obj;
  };

  _.formatDate = function (d) {
    // YYYY-MM-DDTHH:MM:SS in UTC
    function pad(n) {
      return n < 10 ? `0${n}` : n;
    }
    return `${d.getUTCFullYear()}-${pad(d.getUTCMonth() + 1)}-${pad(d.getUTCDate())}T${pad(
      d.getUTCHours()
    )}:${pad(d.getUTCMinutes())}:${pad(d.getUTCSeconds())}`;
  };

  _.safewrap = function (f) {
    return function () {
      try {
        f.apply(this, arguments);
      } catch (e) {
        console.critical('Implementation error. Please contact support@alooma.com.');
      }
    };
  };

  _.safewrap_class = function (klass, functions) {
    for (let i = 0; i < functions.length; i++) {
      klass.prototype[functions[i]] = _.safewrap(klass.prototype[functions[i]]);
    }
  };

  _.strip_empty_properties = function (p) {
    const ret = {};
    _.each(p, function (v, k) {
      if (_.isString(v) && v.length > 0) {
        ret[k] = v;
      }
    });
    return ret;
  };

  /*
   * see aloomaTruncate.ts
   */
  _.truncate = aloomaTruncate;

  _.JSONEncode = (function () {
    return function (mixed_val) {
      const value = mixed_val;

      const quote = function (string) {
        const escapable =
          /[\\\"\x00-\x1f\x7f-\x9f\u00ad\u0600-\u0604\u070f\u17b4\u17b5\u200c-\u200f\u2028-\u202f\u2060-\u206f\ufeff\ufff0-\uffff]/g;
        const meta = {
          // table of character substitutions
          '\b': '\\b',
          '\t': '\\t',
          '\n': '\\n',
          '\f': '\\f',
          '\r': '\\r',
          '"': '\\"',
          '\\': '\\\\',
        };

        escapable.lastIndex = 0;
        return escapable.test(string)
          ? `"${string.replace(escapable, function (a) {
              const c = meta[a];
              return typeof c === 'string'
                ? c
                : `\\u${`0000${a.charCodeAt(0).toString(16)}`.slice(-4)}`;
            })}"`
          : `"${string}"`;
      };

      var str = function (key, holder) {
        let gap = '';
        const indent = '    ';
        let i = 0; // The loop counter.
        let k = ''; // The member key.
        let v = ''; // The member value.
        let length = 0;
        const mind = gap;
        let partial = [];
        let value = holder[key];

        // If the value has a toJSON method, call it to obtain a replacement value.
        if (value && typeof value === 'object' && typeof value.toJSON === 'function') {
          value = value.toJSON(key);
        }

        // What happens next depends on the value's type.
        switch (typeof value) {
          case 'string':
            return quote(value);

          case 'number':
            // JSON numbers must be finite. Encode non-finite numbers as null.
            return isFinite(value) ? String(value) : 'null';

          case 'boolean':
          case 'null':
            // If the value is a boolean or null, convert it to a string. Note:
            // typeof null does not produce 'null'. The case is included here in
            // the remote chance that this gets fixed someday.

            return String(value);

          case 'object':
            // If the type is 'object', we might be dealing with an object or an array or
            // null.
            // Due to a specification blunder in ECMAScript, typeof null is 'object',
            // so watch out for that case.
            if (!value) {
              return 'null';
            }

            // Make an array to hold the partial results of stringifying this object value.
            gap += indent;
            partial = [];

            // Is the value an array?
            if (toString.apply(value) === '[object Array]') {
              // The value is an array. Stringify every element. Use null as a placeholder
              // for non-JSON values.

              length = value.length;
              for (i = 0; i < length; i += 1) {
                partial[i] = str(i, value) || 'null';
              }

              // Join all of the elements together, separated with commas, and wrap them in
              // brackets.
              v =
                partial.length === 0
                  ? '[]'
                  : gap
                  ? `[\n${gap}${partial.join(`,\n${gap}`)}\n${mind}]`
                  : `[${partial.join(',')}]`;
              gap = mind;
              return v;
            }

            // Iterate through all of the keys in the object.
            for (k in value) {
              if (hasOwnProperty.call(value, k)) {
                v = str(k, value);
                if (v) {
                  partial.push(quote(k) + (gap ? ': ' : ':') + v);
                }
              }
            }

            // Join all of the member texts together, separated with commas,
            // and wrap them in braces.
            v =
              partial.length === 0
                ? '{}'
                : gap
                ? `{${partial.join(',')}${mind}}`
                : `{${partial.join(',')}}`;
            gap = mind;
            return v;
        }
      };

      // Make a fake root object containing our value under the key of ''.
      // Return the result of stringifying the value.
      return str('', {
        '': value,
      });
    };
  })();

  _.JSONDecode = (function () {
    // https://github.com/douglascrockford/JSON-js/blob/master/json_parse.js
    let at; // The index of the current character
    let ch; // The current character
    const escapee = {
      '"': '"',
      '\\': '\\',
      '/': '/',
      b: '\b',
      f: '\f',
      n: '\n',
      r: '\r',
      t: '\t',
    };
    let text;
    const error = function (m) {
      throw {
        name: 'SyntaxError',
        message: m,
        at,
        text,
      };
    };
    const next = function (/** *= */ c) {
      // If a c parameter is provided, verify that it matches the current character.
      if (c && c !== ch) {
        error(`Expected '${c}' instead of '${ch}'`);
      }
      // Get the next character. When there are no more characters,
      // return the empty string.
      ch = text.charAt(at);
      at += 1;
      return ch;
    };
    const number = function () {
      // Parse a number value.
      let number;
      let string = '';

      if (ch === '-') {
        string = '-';
        next('-');
      }
      while (ch >= '0' && ch <= '9') {
        string += ch;
        next();
      }
      if (ch === '.') {
        string += '.';
        while (next() && ch >= '0' && ch <= '9') {
          string += ch;
        }
      }
      if (ch === 'e' || ch === 'E') {
        string += ch;
        next();
        if (ch === '-' || ch === '+') {
          string += ch;
          next();
        }
        while (ch >= '0' && ch <= '9') {
          string += ch;
          next();
        }
      }
      number = +string;
      if (!isFinite(number)) {
        error('Bad number');
      } else {
        return number;
      }
    };
    const string = function () {
      // Parse a string value.
      let hex;
      let i;
      let string = '';
      let uffff;
      // When parsing for string values, we must look for " and \ characters.
      if (ch === '"') {
        while (next()) {
          if (ch === '"') {
            next();
            return string;
          }
          if (ch === '\\') {
            next();
            if (ch === 'u') {
              uffff = 0;
              for (i = 0; i < 4; i += 1) {
                hex = parseInt(next(), 16);
                if (!isFinite(hex)) {
                  break;
                }
                uffff = uffff * 16 + hex;
              }
              string += String.fromCharCode(uffff);
            } else if (typeof escapee[ch] === 'string') {
              string += escapee[ch];
            } else {
              break;
            }
          } else {
            string += ch;
          }
        }
      }
      error('Bad string');
    };
    const white = function () {
      // Skip whitespace.
      while (ch && ch <= ' ') {
        next();
      }
    };
    const word = function () {
      // true, false, or null.
      switch (ch) {
        case 't':
          next('t');
          next('r');
          next('u');
          next('e');
          return true;
        case 'f':
          next('f');
          next('a');
          next('l');
          next('s');
          next('e');
          return false;
        case 'n':
          next('n');
          next('u');
          next('l');
          next('l');
          return null;
      }
      error(`Unexpected '${ch}'`);
    };
    let value; // Placeholder for the value function.
    const array = function () {
      // Parse an array value.
      const array = [];

      if (ch === '[') {
        next('[');
        white();
        if (ch === ']') {
          next(']');
          return array; // empty array
        }
        while (ch) {
          array.push(value());
          white();
          if (ch === ']') {
            next(']');
            return array;
          }
          next(',');
          white();
        }
      }
      error('Bad array');
    };
    const object = function () {
      // Parse an object value.
      let key;
      const object = {};

      if (ch === '{') {
        next('{');
        white();
        if (ch === '}') {
          next('}');
          return object; // empty object
        }
        while (ch) {
          key = string();
          white();
          next(':');
          if (Object.hasOwnProperty.call(object, key)) {
            error(`Duplicate key "${key}"`);
          }
          object[key] = value();
          white();
          if (ch === '}') {
            next('}');
            return object;
          }
          next(',');
          white();
        }
      }
      error('Bad object');
    };

    value = function () {
      // Parse a JSON value. It could be an object, an array, a string,
      // a number, or a word.
      white();
      switch (ch) {
        case '{':
          return object();
        case '[':
          return array();
        case '"':
          return string();
        case '-':
          return number();
        default:
          return ch >= '0' && ch <= '9' ? number() : word();
      }
    };

    // Return the json_parse function. It will have access to all of the
    // above functions and variables.
    return function (source) {
      let result;

      text = source;
      at = 0;
      ch = ' ';
      result = value();
      white();
      if (ch) {
        error('Syntax error');
      }

      return result;
    };
  })();

  _.base64Encode = function (data) {
    const b64 = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=';
    let o1;
    let o2;
    let o3;
    let h1;
    let h2;
    let h3;
    let h4;
    let bits;
    let i = 0;
    let ac = 0;
    let enc = '';
    const tmp_arr = [];

    if (!data) {
      return data;
    }

    data = _.utf8Encode(data);

    do {
      // pack three octets into four hexets
      o1 = data.charCodeAt(i++);
      o2 = data.charCodeAt(i++);
      o3 = data.charCodeAt(i++);

      bits = (o1 << 16) | (o2 << 8) | o3;

      h1 = (bits >> 18) & 0x3f;
      h2 = (bits >> 12) & 0x3f;
      h3 = (bits >> 6) & 0x3f;
      h4 = bits & 0x3f;

      // use hexets to index into b64, and append result to encoded string
      tmp_arr[ac++] = b64.charAt(h1) + b64.charAt(h2) + b64.charAt(h3) + b64.charAt(h4);
    } while (i < data.length);

    enc = tmp_arr.join('');

    switch (data.length % 3) {
      case 1:
        enc = `${enc.slice(0, -2)}==`;
        break;
      case 2:
        enc = `${enc.slice(0, -1)}=`;
        break;
    }

    return enc;
  };

  _.utf8Encode = function (string) {
    string = `${string}`.replace(/\r\n/g, '\n').replace(/\r/g, '\n');

    let utftext = '';
    let start;
    let end;
    let stringl = 0;
    let n;

    start = end = 0;
    stringl = string.length;

    for (n = 0; n < stringl; n++) {
      const c1 = string.charCodeAt(n);
      let enc = null;

      if (c1 < 128) {
        end++;
      } else if (c1 > 127 && c1 < 2048) {
        enc = String.fromCharCode((c1 >> 6) | 192, (c1 & 63) | 128);
      } else {
        enc = String.fromCharCode((c1 >> 12) | 224, ((c1 >> 6) & 63) | 128, (c1 & 63) | 128);
      }
      if (enc !== null) {
        if (end > start) {
          utftext += string.substring(start, end);
        }
        utftext += enc;
        start = end = n + 1;
      }
    }

    if (end > start) {
      utftext += string.substring(start, string.length);
    }

    return utftext;
  };

  _.UUID = createUUID;

  // _.isBlockedUA()
  // This is to block various web spiders from executing our JS and
  // sending false tracking data
  _.isBlockedUA = function (ua) {
    if (/(google web preview|baiduspider|yandexbot|bingbot|googlebot|yahoo! slurp)/i.test(ua)) {
      return true;
    }
    return false;
  };

  /**
   * @param {Object=} formdata
   * @param {string=} arg_separator
   */
  _.HTTPBuildQuery = function (formdata, arg_separator) {
    let use_val;
    let use_key;
    const tmp_arr = [];

    if (_.isUndefined(arg_separator)) {
      arg_separator = '&';
    }

    _.each(formdata, function (val, key) {
      use_val = encodeURIComponent(val.toString());
      use_key = encodeURIComponent(key);
      tmp_arr[tmp_arr.length] = `${use_key}=${use_val}`;
    });

    return tmp_arr.join(arg_separator);
  };

  _.getQueryParam = function (url, param) {
    // Expects a raw URL

    param = param.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
    const regexS = `[\\?&]${param}=([^&#]*)`;
    const regex = new RegExp(regexS);
    const results = regex.exec(url);
    if (results === null || (results && typeof results[1] !== 'string' && results[1].length)) {
      return '';
    }
    return decodeURIComponent(results[1]).replace(/\+/g, ' ');
  };

  // _.cookie
  // Methods partially borrowed from quirksmode.org/js/cookies.html
  _.cookie = {
    get(name) {
      const nameEQ = `${name}=`;
      const ca = document.cookie.split(';');
      for (let i = 0; i < ca.length; i++) {
        let c = ca[i];
        while (c.charAt(0) == ' ') c = c.substring(1, c.length);
        if (c.indexOf(nameEQ) == 0) return decodeURIComponent(c.substring(nameEQ.length, c.length));
      }
      return null;
    },

    parse(name) {
      let cookie;
      try {
        cookie = _.JSONDecode(_.cookie.get(name)) || {};
      } catch (err) {}
      return cookie;
    },

    set(name, value, days, cross_subdomain, is_secure) {
      let cdomain = '';
      let expires = '';
      let secure = '';

      if (cross_subdomain) {
        const matches = document.location.hostname.match(/[a-z0-9][a-z0-9\-]+\.[a-z\.]{2,6}$/i);
        const domain = matches ? matches[0] : '';

        cdomain = domain ? `; domain=.${domain}` : '';
      }

      if (days) {
        const date = new Date();
        date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
        expires = `; expires=${date.toGMTString()}`;
      }

      if (is_secure) {
        secure = '; secure';
      }

      document.cookie = `${name}=${encodeURIComponent(value)}${expires}; path=/${cdomain}${secure}`;
    },

    remove(name, cross_subdomain) {
      _.cookie.set(name, '', -1, cross_subdomain);
    },
  };

  // _.localStorage
  _.localStorage = {
    error(msg) {
      console.error(`localStorage error: ${msg}`);
    },

    get(name) {
      try {
        return window.localStorage.getItem(name);
      } catch (err) {
        _.localStorage.error(err);
      }
      return null;
    },

    parse(name) {
      try {
        return _.JSONDecode(_.localStorage.get(name)) || {};
      } catch (err) {}
      return null;
    },

    set(name, value) {
      try {
        window.localStorage.setItem(name, value);
      } catch (err) {
        _.localStorage.error(err);
      }
    },

    remove(name) {
      try {
        window.localStorage.removeItem(name);
      } catch (err) {
        _.localStorage.error(err);
      }
    },
  };

  _.register_event = (function () {
    // written by Dean Edwards, 2005
    // with input from Tino Zijdel - crisp@xs4all.nl
    // with input from Carl Sverre - mail@carlsverre.com
    // with input from Alooma
    // http://dean.edwards.name/weblog/2005/10/add-event/
    // https://gist.github.com/1930440

    /**
     * @param {Object} element
     * @param {string} type
     * @param {function(...)} handler
     * @param {boolean=} oldSchool
     */
    const register_event = function (element, type, handler, oldSchool) {
      if (!element) {
        console.error('No valid element provided to register_event');
        return;
      }

      if (element.addEventListener && !oldSchool) {
        element.addEventListener(type, handler, false);
      } else {
        const ontype = `on${type}`;
        const old_handler = element[ontype]; // can be undefined
        element[ontype] = makeHandler(element, handler, old_handler);
      }
    };

    function makeHandler(element, new_handler, old_handlers) {
      const handler = function (event) {
        event = event || fixEvent(window.event);

        // this basically happens in firefox whenever another script
        // overwrites the onload callback and doesn't pass the event
        // object to previously defined callbacks.  All the browsers
        // that don't define window.event implement addEventListener
        // so the dom_loaded handler will still be fired as usual.
        if (!event) {
          return undefined;
        }

        let ret = true;
        let old_result;
        let new_result;

        if (_.isFunction(old_handlers)) {
          old_result = old_handlers(event);
        }
        new_result = new_handler.call(element, event);

        if (old_result === false || new_result === false) {
          ret = false;
        }

        return ret;
      };

      return handler;
    }
    function fixEvent(event) {
      if (event) {
        event.preventDefault = fixEvent.preventDefault;
        event.stopPropagation = fixEvent.stopPropagation;
      }
      return event;
    }
    fixEvent.preventDefault = function () {
      this.returnValue = false;
    };
    fixEvent.stopPropagation = function () {
      this.cancelBubble = true;
    };

    return register_event;
  })();

  _.dom_query = (function () {
    /* document.getElementsBySelector(selector)
          - returns an array of element objects from the current document
          matching the CSS selector. Selectors can contain element names,
          class names and ids and can be nested. For example:
          elements = document.getElementsBySelector('div#main p a.external')
          Will return an array of all 'a' elements with 'external' in their
          class attribute that are contained inside 'p' elements that are
          contained inside the 'div' element which has id="main"
          New in version 0.4: Support for CSS2 and CSS3 attribute selectors:
          See http://www.w3.org/TR/css3-selectors/#attribute-selectors
          Version 0.4 - Simon Willison, March 25th 2003
          -- Works in Phoenix 0.5, Mozilla 1.3, Opera 7, Internet Explorer 6, Internet Explorer 5 on Windows
          -- Opera 7 fails
          Version 0.5 - Carl Sverre, Jan 7th 2013
          -- Now uses jQuery-esque `hasClass` for testing class name
          equality.  This fixes a bug related to '-' characters being
          considered not part of a 'word' in regex.
          */

    function getAllChildren(e) {
      // Returns all children of element. Workaround required for IE5/Windows. Ugh.
      return e.all ? e.all : e.getElementsByTagName('*');
    }

    const bad_whitespace = /[\t\r\n]/g;
    function hasClass(elem, selector) {
      const className = ` ${selector} `;
      return ` ${elem.className} `.replace(bad_whitespace, ' ').indexOf(className) >= 0;
    }

    function getElementsBySelector(selector) {
      // Attempt to fail gracefully in lesser browsers
      if (!document.getElementsByTagName) {
        return new Array();
      }
      // Split selector in to tokens
      const tokens = selector.split(' ');
      let token;
      let currentContext = new Array(document);
      for (let i = 0; i < tokens.length; i++) {
        token = tokens[i].replace(/^\s+/, '').replace(/\s+$/, '');
        if (token.indexOf('#') > -1) {
          // Token is an ID selector
          var bits = token.split('#');
          var tagName = bits[0];
          const id = bits[1];
          const element = document.getElementById(id);
          if (!element || (tagName && element.nodeName.toLowerCase() != tagName)) {
            // element not found or tag with that ID not found, return false
            return new Array();
          }
          // Set currentContext to contain just this element
          currentContext = new Array(element);
          continue; // Skip to next token
        }
        if (token.indexOf('.') > -1) {
          // Token contains a class selector
          var bits = token.split('.');
          var tagName = bits[0];
          const className = bits[1];
          if (!tagName) {
            tagName = '*';
          }
          // Get elements matching tag, filter them for class selector
          var found = new Array();
          var foundCount = 0;
          for (var h = 0; h < currentContext.length; h++) {
            var elements;
            if (tagName == '*') {
              elements = getAllChildren(currentContext[h]);
            } else {
              elements = currentContext[h].getElementsByTagName(tagName);
            }
            for (var j = 0; j < elements.length; j++) {
              found[foundCount++] = elements[j];
            }
          }
          currentContext = new Array();
          var currentContextIndex = 0;
          for (var k = 0; k < found.length; k++) {
            if (
              found[k].className &&
              _.isString(found[k].className) && // some SVG elements have classNames which are not strings
              hasClass(found[k], className)
            ) {
              currentContext[currentContextIndex++] = found[k];
            }
          }
          continue; // Skip to next token
        }
        // Code to deal with attribute selectors
        const token_match = token.match(/^(\w*)\[(\w+)([=~\|\^\$\*]?)=?"?([^\]"]*)"?\]$/);
        if (token_match) {
          var tagName = token_match[1];
          var attrName = token_match[2];
          const attrOperator = token_match[3];
          var attrValue = token_match[4];
          if (!tagName) {
            tagName = '*';
          }
          // Grab all of the tagName elements within current context
          var found = new Array();
          var foundCount = 0;
          for (var h = 0; h < currentContext.length; h++) {
            var elements;
            if (tagName == '*') {
              elements = getAllChildren(currentContext[h]);
            } else {
              elements = currentContext[h].getElementsByTagName(tagName);
            }
            for (var j = 0; j < elements.length; j++) {
              found[foundCount++] = elements[j];
            }
          }
          currentContext = new Array();
          var currentContextIndex = 0;
          var checkFunction; // This function will be used to filter the elements
          switch (attrOperator) {
            case '=': // Equality
              checkFunction = function (e) {
                return e.getAttribute(attrName) == attrValue;
              };
              break;
            case '~': // Match one of space seperated words
              checkFunction = function (e) {
                return e.getAttribute(attrName).match(new RegExp(`\\b${attrValue}\\b`));
              };
              break;
            case '|': // Match start with value followed by optional hyphen
              checkFunction = function (e) {
                return e.getAttribute(attrName).match(new RegExp(`^${attrValue}-?`));
              };
              break;
            case '^': // Match starts with value
              checkFunction = function (e) {
                return e.getAttribute(attrName).indexOf(attrValue) == 0;
              };
              break;
            case '$': // Match ends with value - fails with "Warning" in Opera 7
              checkFunction = function (e) {
                return (
                  e.getAttribute(attrName).lastIndexOf(attrValue) ==
                  e.getAttribute(attrName).length - attrValue.length
                );
              };
              break;
            case '*': // Match ends with value
              checkFunction = function (e) {
                return e.getAttribute(attrName).indexOf(attrValue) > -1;
              };
              break;
            default:
              // Just test for existence of attribute
              checkFunction = function (e) {
                return e.getAttribute(attrName);
              };
          }
          currentContext = new Array();
          currentContextIndex = 0;
          for (var k = 0; k < found.length; k++) {
            if (checkFunction(found[k])) {
              currentContext[currentContextIndex++] = found[k];
            }
          }
          // alert('Attribute Selector: '+tagName+' '+attrName+' '+attrOperator+' '+attrValue);
          continue; // Skip to next token
        }
        // If we get here, token is JUST an element (not a class or ID selector)
        tagName = token;
        var found = new Array();
        var foundCount = 0;
        for (var h = 0; h < currentContext.length; h++) {
          var elements = currentContext[h].getElementsByTagName(tagName);
          for (var j = 0; j < elements.length; j++) {
            found[foundCount++] = elements[j];
          }
        }
        currentContext = found;
      }
      return currentContext;
    }
    return getElementsBySelector;
  })();

  _.info = {
    campaignParams() {
      const campaign_keywords = 'utm_source utm_medium utm_campaign utm_content utm_term'.split(
        ' '
      );
      let kw = '';
      const params = {};
      _.each(campaign_keywords, function (kwkey) {
        kw = _.getQueryParam(document.URL, kwkey);
        if (kw.length) {
          params[kwkey] = kw;
        }
      });

      return params;
    },

    searchEngine(referrer) {
      if (referrer.search('https?://(.*)google.([^/?]*)') === 0) {
        return 'google';
      }
      if (referrer.search('https?://(.*)bing.com') === 0) {
        return 'bing';
      }
      if (referrer.search('https?://(.*)yahoo.com') === 0) {
        return 'yahoo';
      }
      if (referrer.search('https?://(.*)duckduckgo.com') === 0) {
        return 'duckduckgo';
      }
      return null;
    },

    searchInfo(referrer) {
      const search = _.info.searchEngine(referrer);
      const param = search != 'yahoo' ? 'q' : 'p';
      const ret = {};

      if (search !== null) {
        ret.$search_engine = search;

        const keyword = _.getQueryParam(referrer, param);
        if (keyword.length) {
          ret.mp_keyword = keyword;
        }
      }

      return ret;
    },

    /**
     * This function detects which browser is running this script.
     * The order of the checks are important since many user agents
     * include key words used in later checks.
     */
    browser(user_agent, vendor, opera) {
      vendor = vendor || ''; // vendor is undefined for at least IE9
      if (opera || _.includes(user_agent, ' OPR/')) {
        if (_.includes(user_agent, 'Mini')) {
          return 'Opera Mini';
        }
        return 'Opera';
      }
      if (/(BlackBerry|PlayBook|BB10)/i.test(user_agent)) {
        return 'BlackBerry';
      }
      if (_.includes(user_agent, 'IEMobile') || _.includes(user_agent, 'WPDesktop')) {
        return 'Internet Explorer Mobile';
      }
      if (_.includes(user_agent, 'Edge')) {
        return 'Microsoft Edge';
      }
      if (_.includes(user_agent, 'FBIOS')) {
        return 'Facebook Mobile';
      }
      if (_.includes(user_agent, 'Chrome')) {
        return 'Chrome';
      }
      if (_.includes(user_agent, 'CriOS')) {
        return 'Chrome iOS';
      }
      if (_.includes(vendor, 'Apple')) {
        if (_.includes(user_agent, 'Mobile')) {
          return 'Mobile Safari';
        }
        return 'Safari';
      }
      if (_.includes(user_agent, 'Android')) {
        return 'Android Mobile';
      } else if (_.includes(user_agent, 'Konqueror')) {
        return 'Konqueror';
      } else if (_.includes(user_agent, 'Firefox')) {
        return 'Firefox';
      } else if (_.includes(user_agent, 'MSIE') || _.includes(user_agent, 'Trident/')) {
        return 'Internet Explorer';
      } else if (_.includes(user_agent, 'Gecko')) {
        return 'Mozilla';
      } else {
        return '';
      }
    },

    /**
     * This function detects which browser version is running this script,
     * parsing major and minor version (e.g., 42.1). User agent strings from:
     * http://www.useragentstring.com/pages/useragentstring.php
     */
    browserVersion(userAgent, vendor, opera) {
      const browser = _.info.browser(userAgent, vendor, opera);
      const versionRegexs = {
        'Internet Explorer Mobile': /rv:(\d+(\.\d+)?)/,
        'Microsoft Edge': /Edge\/(\d+(\.\d+)?)/,
        Chrome: /Chrome\/(\d+(\.\d+)?)/,
        'Chrome iOS': /Chrome\/(\d+(\.\d+)?)/,
        Safari: /Version\/(\d+(\.\d+)?)/,
        'Mobile Safari': /Version\/(\d+(\.\d+)?)/,
        Opera: /(Opera|OPR)\/(\d+(\.\d+)?)/,
        Firefox: /Firefox\/(\d+(\.\d+)?)/,
        Konqueror: /Konqueror:(\d+(\.\d+)?)/,
        BlackBerry: /BlackBerry (\d+(\.\d+)?)/,
        'Android Mobile': /android\s(\d+(\.\d+)?)/,
        'Internet Explorer': /(rv:|MSIE )(\d+(\.\d+)?)/,
        Mozilla: /rv:(\d+(\.\d+)?)/,
      };
      const regex = versionRegexs[browser];
      if (regex == undefined) {
        return null;
      }
      const matches = userAgent.match(regex);
      if (!matches) {
        return null;
      }
      return parseFloat(matches[matches.length - 2]);
    },

    os() {
      const a = userAgent;
      if (/Windows/i.test(a)) {
        if (/Phone/.test(a) || /WPDesktop/.test(a)) {
          return 'Windows Phone';
        }
        return 'Windows';
      }
      if (/(iPhone|iPad|iPod)/.test(a)) {
        return 'iOS';
      }
      if (/Android/.test(a)) {
        return 'Android';
      }
      if (/(BlackBerry|PlayBook|BB10)/i.test(a)) {
        return 'BlackBerry';
      }
      if (/Mac/i.test(a)) {
        return 'Mac OS X';
      }
      if (/Linux/.test(a)) {
        return 'Linux';
      }
      return '';
    },

    device(user_agent) {
      if (/Windows Phone/i.test(user_agent) || /WPDesktop/.test(user_agent)) {
        return 'Windows Phone';
      }
      if (/iPad/.test(user_agent)) {
        return 'iPad';
      }
      if (/iPod/.test(user_agent)) {
        return 'iPod Touch';
      }
      if (/iPhone/.test(user_agent)) {
        return 'iPhone';
      }
      if (/(BlackBerry|PlayBook|BB10)/i.test(user_agent)) {
        return 'BlackBerry';
      }
      if (/Android/.test(user_agent)) {
        return 'Android';
      }
      return '';
    },

    referringDomain(referrer) {
      const split = referrer.split('/');
      if (split.length >= 3) {
        return split[2];
      }
      return '';
    },

    properties() {
      return _.extend(
        _.strip_empty_properties({
          $os: _.info.os(),
          $browser: _.info.browser(userAgent, navigator.vendor, window.opera),
          $referrer: document.referrer,
          $referring_domain: _.info.referringDomain(document.referrer),
          $device: _.info.device(userAgent),
        }),
        {
          $current_url: window.location.href,
          $browser_version: _.info.browserVersion(userAgent, navigator.vendor, window.opera),
          $screen_height: screen.height,
          $screen_width: screen.width,
          mp_lib: 'web',
          $lib_version: LIB_VERSION,
        }
      );
    },

    people_properties() {
      return _.extend(
        _.strip_empty_properties({
          $os: _.info.os(),
          $browser: _.info.browser(userAgent, navigator.vendor, window.opera),
        }),
        {
          $browser_version: _.info.browserVersion(userAgent, navigator.vendor, window.opera),
        }
      );
    },

    pageviewInfo(page) {
      return _.strip_empty_properties({
        mp_page: page,
        mp_referrer: document.referrer,
        mp_browser: _.info.browser(userAgent, navigator.vendor, window.opera),
        mp_platform: _.info.os(),
      });
    },
  };

  // save reference to navigator.sendBeacon so it can be minified
  var sendBeacon = navigator['sendBeacon'];
  if (sendBeacon) {
    sendBeacon = _.bind(sendBeacon, navigator);
  }

  // Console override
  var console = {
    /** @type {function(...)} */
    log() {
      if (DEBUG && !_.isUndefined(windowConsole) && windowConsole) {
        try {
          windowConsole.log.apply(windowConsole, arguments);
        } catch (err) {
          _.each(arguments, function (arg) {
            windowConsole.log(arg);
          });
        }
      }
    },
    /** @type {function(...)} */
    error() {
      if (DEBUG && !_.isUndefined(windowConsole) && windowConsole) {
        const args = ['Alooma error:'].concat(_.toArray(arguments));
        try {
          windowConsole.error.apply(windowConsole, args);
        } catch (err) {
          _.each(args, function (arg) {
            windowConsole.error(arg);
          });
        }
      }
    },
    /** @type {function(...)} */
    critical() {
      if (!_.isUndefined(windowConsole) && windowConsole) {
        const args = ['Alooma error:'].concat(_.toArray(arguments));
        try {
          windowConsole.error.apply(windowConsole, args);
        } catch (err) {
          _.each(args, function (arg) {
            windowConsole.error(arg);
          });
        }
      }
    },
  };

  /**
   * DomTracker Object
   * @constructor
   */
  const DomTracker = function () {};

  // interface
  DomTracker.prototype.create_properties = function () {};
  DomTracker.prototype.event_handler = function () {};
  DomTracker.prototype.after_track_handler = function () {};

  DomTracker.prototype.init = function (alooma_instance) {
    this.mp = alooma_instance;
    return this;
  };

  /**
   * @param {string} query
   * @param {string} event_name
   * @param {Object=} properties
   * @param {function(...)=} user_callback
   */
  DomTracker.prototype.track = function (query, event_name, properties, user_callback) {
    const that = this;
    const elements = _.dom_query(query);

    if (elements.length == 0) {
      console.error(`The DOM query (${query}) returned 0 elements`);
      return;
    }

    _.each(
      elements,
      function (element) {
        _.register_event(element, this.override_event, function (e) {
          const options = {};
          const props = that.create_properties(properties, this);
          const timeout = that.mp.get_config('track_links_timeout');

          that.event_handler(e, this, options);

          // in case the alooma servers don't get back to us in time
          window.setTimeout(that.track_callback(user_callback, props, options, true), timeout);

          // fire the tracking event
          that.mp.track(event_name, props, that.track_callback(user_callback, props, options));
        });
      },
      this
    );

    return true;
  };

  /**
   * @param {function(...)} user_callback
   * @param {Object} props
   * @param {boolean=} timeout_occured
   */
  DomTracker.prototype.track_callback = function (user_callback, props, options, timeout_occured) {
    timeout_occured = timeout_occured || false;
    const that = this;

    return function () {
      // options is referenced from both callbacks, so we can have
      // a "lock" of sorts to ensure only one fires
      if (options.callback_fired) {
        return;
      }
      options.callback_fired = true;

      if (user_callback && user_callback(timeout_occured, props) === false) {
        // user can prevent the default functionality by
        // returning false from their callback
        return;
      }

      that.after_track_handler(props, options, timeout_occured);
    };
  };

  DomTracker.prototype.create_properties = function (properties, element) {
    let props;

    if (typeof properties === 'function') {
      props = properties(element);
    } else {
      props = _.extend({}, properties);
    }

    return props;
  };

  /**
   * LinkTracker Object
   * @constructor
   * @extends DomTracker
   */
  const LinkTracker = function () {
    this.override_event = 'click';
  };
  _.inherit(LinkTracker, DomTracker);

  LinkTracker.prototype.create_properties = function (properties, element) {
    const props = LinkTracker.superclass.create_properties.apply(this, arguments);

    if (element.href) {
      props.url = element.href;
    }

    return props;
  };

  LinkTracker.prototype.event_handler = function (evt, element, options) {
    options.new_tab = evt.which === 2 || evt.metaKey || evt.ctrlKey || element.target === '_blank';
    options.href = element.href;

    if (!options.new_tab) {
      evt.preventDefault();
    }
  };

  LinkTracker.prototype.after_track_handler = function (props, options, timeout_occured) {
    if (options.new_tab) {
      return;
    }

    setTimeout(function () {
      window.location = options.href;
    }, 0);
  };

  /**
   * FormTracker Object
   * @constructor
   * @extends DomTracker
   */
  const FormTracker = function () {
    this.override_event = 'submit';
  };
  _.inherit(FormTracker, DomTracker);

  FormTracker.prototype.event_handler = function (evt, element, options) {
    options.element = element;
    evt.preventDefault();
  };

  FormTracker.prototype.after_track_handler = function (props, options, timeout_occured) {
    setTimeout(function () {
      options.element.submit();
    }, 0);
  };

  /**
   * Alooma Persistence Object
   * @constructor
   */
  const AloomaPersistence = function (config) {
    this.props = {};
    this.campaign_params_saved = false;

    if (config.persistence_name) {
      this.name = `mp_${config.persistence_name}`;
    } else {
      this.name = `mp_${config.token}_alooma`;
    }

    let storage_type = config.persistence;
    if (storage_type !== 'cookie' && storage_type !== 'localStorage') {
      console.critical(`Unknown persistence type "${storage_type}"; falling back to "cookie"`);
      storage_type = config.persistence = 'cookie';
    }

    const localStorage_supported = function () {
      let supported = true;
      try {
        const key = '__mplssupport__';
        const val = 'xyz';
        _.localStorage.set(key, val);
        if (_.localStorage.get(key) !== val) {
          supported = false;
        }
        _.localStorage.remove(key);
      } catch (err) {
        supported = false;
      }
      if (!supported) {
        console.error('localStorage unsupported; falling back to cookie store');
      }
      return supported;
    };
    if (storage_type === 'localStorage' && localStorage_supported()) {
      this.storage = _.localStorage;
    } else {
      this.storage = _.cookie;
    }

    this.load();
    this.update_config(config);
    this.upgrade(config);
    this.save();
  };

  AloomaPersistence.prototype.properties = function () {
    const p = {};
    // Filter out reserved properties
    _.each(this.props, function (v, k) {
      if (!_.include(RESERVED_PROPERTIES, k)) {
        p[k] = v;
      }
    });
    return p;
  };

  AloomaPersistence.prototype.load = function () {
    if (this.disabled) {
      return;
    }

    const entry = this.storage.parse(this.name);

    if (entry) {
      this.props = _.extend({}, entry);
    }
  };

  AloomaPersistence.prototype.upgrade = function (config) {
    const upgrade_from_old_lib = config.upgrade;
    let old_cookie_name;
    let old_cookie;

    if (upgrade_from_old_lib) {
      old_cookie_name = 'mp_super_properties';
      // Case where they had a custom cookie name before.
      if (typeof upgrade_from_old_lib === 'string') {
        old_cookie_name = upgrade_from_old_lib;
      }

      old_cookie = this.storage.parse(old_cookie_name);

      // remove the cookie
      this.storage.remove(old_cookie_name);
      this.storage.remove(old_cookie_name, true);

      if (old_cookie) {
        this.props = _.extend(this.props, old_cookie.all, old_cookie.events);
      }
    }

    if (!config.cookie_name && config.name !== 'alooma') {
      // special case to handle people with cookies of the form
      // mp_TOKEN_INSTANCENAME from the first release of this library
      old_cookie_name = `mp_${config.token}_${config.name}`;
      old_cookie = this.storage.parse(old_cookie_name);

      if (old_cookie) {
        this.storage.remove(old_cookie_name);
        this.storage.remove(old_cookie_name, true);

        // Save the prop values that were in the cookie from before -
        // this should only happen once as we delete the old one.
        this.register_once(old_cookie);
      }
    }

    if (this.storage === _.localStorage) {
      old_cookie = _.cookie.parse(this.name);

      _.cookie.remove(this.name);
      _.cookie.remove(this.name, true);

      if (old_cookie) {
        this.register_once(old_cookie);
      }
    }
  };

  AloomaPersistence.prototype.save = function () {
    if (this.disabled) {
      return;
    }
    this._expire_notification_campaigns();
    this.storage.set(
      this.name,
      _.JSONEncode(this.props),
      this.expire_days,
      this.cross_subdomain,
      this.secure
    );
  };

  AloomaPersistence.prototype.remove = function () {
    // remove both domain and subdomain cookies
    this.storage.remove(this.name, false);
    this.storage.remove(this.name, true);
  };

  // removes the storage entry and deletes all loaded data
  // forced name for tests
  AloomaPersistence.prototype.clear = function () {
    this.remove();
    this.props = {};
  };

  /**
   * @param {Object} props
   * @param {*=} default_value
   * @param {number=} days
   */
  AloomaPersistence.prototype.register_once = function (props, default_value, days) {
    if (_.isObject(props)) {
      if (typeof default_value === 'undefined') {
        default_value = 'None';
      }
      this.expire_days = typeof days === 'undefined' ? this.default_expiry : days;

      _.each(
        props,
        function (val, prop) {
          if (!this.props[prop] || this.props[prop] === default_value) {
            this.props[prop] = val;
          }
        },
        this
      );

      this.save();

      return true;
    }
    return false;
  };

  /**
   * @param {Object} props
   * @param {number=} days
   */
  AloomaPersistence.prototype.register = function (props, days) {
    if (_.isObject(props)) {
      this.expire_days = typeof days === 'undefined' ? this.default_expiry : days;

      _.extend(this.props, props);

      this.save();

      return true;
    }
    return false;
  };

  AloomaPersistence.prototype.unregister = function (prop) {
    if (prop in this.props) {
      delete this.props[prop];
      this.save();
    }
  };

  AloomaPersistence.prototype._expire_notification_campaigns = _.safewrap(function () {
    const campaigns_shown = this.props[CAMPAIGN_IDS_KEY];
    const EXPIRY_TIME = DEBUG ? 60 * 1000 : 60 * 60 * 1000; // 1 minute (DEBUG) / 1 hour (PDXN)
    if (!campaigns_shown) {
      return;
    }
    for (const campaign_id in campaigns_shown) {
      if (1 * new Date() - campaigns_shown[campaign_id] > EXPIRY_TIME) {
        delete campaigns_shown[campaign_id];
      }
    }
    if (_.isEmptyObject(campaigns_shown)) {
      delete this.props[CAMPAIGN_IDS_KEY];
    }
  });

  AloomaPersistence.prototype.update_campaign_params = function () {
    if (!this.campaign_params_saved) {
      this.register_once(_.info.campaignParams());
      this.campaign_params_saved = true;
    }
  };

  AloomaPersistence.prototype.update_search_keyword = function (referrer) {
    this.register(_.info.searchInfo(referrer));
  };

  // EXPORTED METHOD, we test this directly.
  AloomaPersistence.prototype.update_referrer_info = function (referrer) {
    // If referrer doesn't exist, we want to note the fact that it was type-in traffic.
    this.register_once(
      {
        $initial_referrer: referrer || '$direct',
        $initial_referring_domain: _.info.referringDomain(referrer) || '$direct',
      },
      ''
    );
  };

  AloomaPersistence.prototype.get_referrer_info = function () {
    return _.strip_empty_properties({
      $initial_referrer: this.props.$initial_referrer,
      $initial_referring_domain: this.props.$initial_referring_domain,
    });
  };

  // safely fills the passed in object with stored properties,
  // does not override any properties defined in both
  // returns the passed in object
  AloomaPersistence.prototype.safe_merge = function (props) {
    _.each(this.props, function (val, prop) {
      if (!(prop in props)) {
        props[prop] = val;
      }
    });

    return props;
  };

  AloomaPersistence.prototype.update_config = function (config) {
    this.default_expiry = this.expire_days = config.cookie_expiration;
    this.set_disabled(config.disable_persistence);
    this.set_cross_subdomain(config.cross_subdomain_cookie);
    this.set_secure(config.secure_cookie);
  };

  AloomaPersistence.prototype.set_disabled = function (disabled) {
    this.disabled = disabled;
    if (this.disabled) {
      this.remove();
    }
  };

  AloomaPersistence.prototype.set_cross_subdomain = function (cross_subdomain) {
    if (cross_subdomain !== this.cross_subdomain) {
      this.cross_subdomain = cross_subdomain;
      this.remove();
      this.save();
    }
  };

  AloomaPersistence.prototype.get_cross_subdomain = function () {
    return this.cross_subdomain;
  };

  AloomaPersistence.prototype.set_secure = function (secure) {
    if (secure !== this.secure) {
      this.secure = !!secure;
      this.remove();
      this.save();
    }
  };

  AloomaPersistence.prototype._add_to_people_queue = function (queue, data) {
    const q_key = this._get_queue_key(queue);
    const q_data = data[queue];
    const set_q = this._get_or_create_queue(SET_ACTION);
    const set_once_q = this._get_or_create_queue(SET_ONCE_ACTION);
    const add_q = this._get_or_create_queue(ADD_ACTION);
    const union_q = this._get_or_create_queue(UNION_ACTION);
    const append_q = this._get_or_create_queue(APPEND_ACTION, []);

    if (q_key === SET_QUEUE_KEY) {
      // Update the set queue - we can override any existing values
      _.extend(set_q, q_data);
      // if there was a pending increment, override it
      // with the set.
      this._pop_from_people_queue(ADD_ACTION, q_data);
      // if there was a pending union, override it
      // with the set.
      this._pop_from_people_queue(UNION_ACTION, q_data);
    } else if (q_key === SET_ONCE_QUEUE_KEY) {
      // only queue the data if there is not already a set_once call for it.
      _.each(q_data, function (v, k) {
        if (!(k in set_once_q)) {
          set_once_q[k] = v;
        }
      });
    } else if (q_key === ADD_QUEUE_KEY) {
      _.each(
        q_data,
        function (v, k) {
          // If it exists in the set queue, increment
          // the value
          if (k in set_q) {
            set_q[k] += v;
          } else {
            // If it doesn't exist, update the add
            // queue
            if (!(k in add_q)) {
              add_q[k] = 0;
            }
            add_q[k] += v;
          }
        },
        this
      );
    } else if (q_key === UNION_QUEUE_KEY) {
      _.each(q_data, function (v, k) {
        if (_.isArray(v)) {
          if (!(k in union_q)) {
            union_q[k] = [];
          }
          // We may send duplicates, the server will dedup them.
          union_q[k] = union_q[k].concat(v);
        }
      });
    } else if (q_key === APPEND_QUEUE_KEY) {
      append_q.push(q_data);
    }

    console.log('ALOOMA PEOPLE REQUEST (QUEUED, PENDING IDENTIFY):');
    console.log(data);

    this.save();
  };

  AloomaPersistence.prototype._pop_from_people_queue = function (queue, data) {
    const q = this._get_queue(queue);
    if (!_.isUndefined(q)) {
      _.each(
        data,
        function (v, k) {
          delete q[k];
        },
        this
      );

      this.save();
    }
  };

  AloomaPersistence.prototype._get_queue_key = function (queue) {
    if (queue === SET_ACTION) {
      return SET_QUEUE_KEY;
    }
    if (queue === SET_ONCE_ACTION) {
      return SET_ONCE_QUEUE_KEY;
    }
    if (queue === ADD_ACTION) {
      return ADD_QUEUE_KEY;
    }
    if (queue === APPEND_ACTION) {
      return APPEND_QUEUE_KEY;
    }
    if (queue === UNION_ACTION) {
      return UNION_QUEUE_KEY;
    }
    console.error('Invalid queue:', queue);
  };

  AloomaPersistence.prototype._get_queue = function (queue) {
    return this.props[this._get_queue_key(queue)];
  };
  AloomaPersistence.prototype._get_or_create_queue = function (queue, default_val) {
    const key = this._get_queue_key(queue);
    default_val = _.isUndefined(default_val) ? {} : default_val;

    return this.props[key] || (this.props[key] = default_val);
  };

  AloomaPersistence.prototype.set_event_timer = function (event_name, timestamp) {
    const timers = this.props[EVENT_TIMERS_KEY] || {};
    timers[event_name] = timestamp;
    this.props[EVENT_TIMERS_KEY] = timers;
    this.save();
  };

  AloomaPersistence.prototype.remove_event_timer = function (event_name) {
    const timers = this.props[EVENT_TIMERS_KEY] || {};
    const timestamp = timers[event_name];
    if (!_.isUndefined(timestamp)) {
      delete this.props[EVENT_TIMERS_KEY][event_name];
      this.save();
    }
    return timestamp;
  };

  /**
   * create_mplib(token:string, config:object, name:string)
   *
   * This function is used by the init method of AloomaLib objects
   * as well as the main initializer at the end of the JSLib (that
   * initializes document.alooma as well as any additional instances
   * declared before this file has loaded).
   */
  const create_mplib = function (token, config, name) {
    let instance;
    const target = name === PRIMARY_INSTANCE_NAME ? alooma_master : alooma_master[name];

    if (target && init_type === INIT_MODULE) {
      instance = target;
    } else {
      if (target && !_.isArray(target)) {
        console.error(`You have already initialized ${name}`);
        return;
      }
      instance = new AloomaLib();
    }

    instance._init(token, config, name);

    // if any instance on the page has debug = true, we set the
    // global debug to be true
    DEBUG = DEBUG || instance.get_config('debug');

    // if target is not defined, we called init after the lib already
    // loaded, so there won't be an array of things to execute
    if (!_.isUndefined(target) && _.isArray(target)) {
      // Original lib calls _execute_array here, but we want to defer the bootloader calls
      // until the after the decorators in eventstream/index.js have been applied
      window.Rover = window.Rover || {};
      window.Rover.bootloaderCalls = target;
    }

    return instance;
  };

  /**
   * Alooma Library Object
   * @constructor
   */
  var AloomaLib = function () {};

  // Initialization methods

  /**
   * This function initializes a new instance of the Alooma tracking object.
   * All new instances are added to the main alooma object as sub properties (such as
   * alooma.library_name) and also returned by this function. To define a
   * second instance on the page, you would call:
   *
   *     alooma.init("new token", { your: "config" }, "library_name");
   *
   * and use it like so:
   *
   *     alooma.library_name.track(...);
   *
   * @param {String} token   Your Alooma API token
   * @param {Object} [config]  A dictionary of config options to override
   * @param {String} [name]    The name for the new alooma instance that you want created
   */
  AloomaLib.prototype.init = function (token, config, name) {
    if (_.isUndefined(name)) {
      console.error('You must name your new library: init(token, config, name)');
      return;
    }
    if (name === PRIMARY_INSTANCE_NAME) {
      console.error(
        'You must initialize the main alooma object right after you include the Alooma js snippet'
      );
      return;
    }

    const instance = create_mplib(token, config, name);
    alooma_master[name] = instance;
    instance._loaded();

    return instance;
  };

  // alooma._init(token:string, config:object, name:string)
  //
  // This function sets up the current instance of the alooma
  // library.  The difference between this method and the init(...)
  // method is this one initializes the actual instance, whereas the
  // init(...) method sets up a new library and calls _init on it.
  //
  AloomaLib.prototype._init = function (token, config, name) {
    this.__loaded = true;
    this.config = {};

    this.set_config(
      _.extend({}, DEFAULT_CONFIG, config, {
        name,
        token,
        callback_fn: `${
          name === PRIMARY_INSTANCE_NAME ? name : `${PRIMARY_INSTANCE_NAME}.${name}`
        }._jsc`,
      })
    );

    this._jsc = function () {};

    this.__dom_loaded_queue = [];
    this.__request_queue = [];
    this.__disabled_events = [];
    this._flags = {
      disable_all_events: false,
      identify_called: false,
    };

    this.persistence = this.cookie = new AloomaPersistence(this.config);
    this.register_once({ distinct_id: _.UUID() }, '');
  };

  // Private methods

  AloomaLib.prototype._loaded = function () {
    this.get_config('loaded')(this);

    // this happens after so a user can call identify/name_tag in
    // the loaded callback
    if (this.get_config('track_pageview')) {
      this.track_pageview();
    }
  };

  AloomaLib.prototype._dom_loaded = function () {
    _.each(
      this.__dom_loaded_queue,
      function (item) {
        this._track_dom.apply(this, item);
      },
      this
    );
    _.each(
      this.__request_queue,
      function (item) {
        this._send_request.apply(this, item);
      },
      this
    );
    delete this.__dom_loaded_queue;
    delete this.__request_queue;
  };

  AloomaLib.prototype._track_dom = function (DomClass, args) {
    if (this.get_config('img')) {
      console.error("You can't use DOM tracking functions with img = true.");
      return false;
    }

    if (!DOM_LOADED) {
      this.__dom_loaded_queue.push([DomClass, args]);
      return false;
    }

    const dt = new DomClass().init(this);
    return dt.track.apply(dt, args);
  };

  /**
   * _prepare_callback() should be called by callers of _send_request for use
   * as the callback argument.
   *
   * If there is no callback, this returns null.
   * If we are going to make XHR/XDR requests, this returns a function.
   * If we are going to use script tags, this returns a string to use as the
   * callback GET param.
   */
  AloomaLib.prototype._prepare_callback = function (callback, data) {
    if (_.isUndefined(callback) || callback === null) {
      return null;
    }

    if (USE_XHR) {
      const callback_function = function (response) {
        callback(response, data);
      };
      return callback_function;
    }
    // if the user gives us a callback, we store as a random
    // property on this instances jsc function and update our
    // callback string to reflect that.
    const jsc = this._jsc;
    const randomized_cb = `${Math.floor(Math.random() * 100000000)}`;
    const callback_string = `${this.get_config('callback_fn')}["${randomized_cb}"]`;
    jsc[randomized_cb] = function (response) {
      delete jsc[randomized_cb];
      callback(response, data);
    };
    return callback_string;
  };

  AloomaLib.prototype._send_request = function (url, data, options, callback) {
    if (ENQUEUE_REQUESTS) {
      this.__request_queue.push(arguments);
      return;
    }

    var DEFAULT_OPTIONS = {
      method: this.get_config('api_method'),
      transport: this.get_config('api_transport'),
    };
    var body_data = null;

    if (!callback && (_.isFunction(options) || typeof options === 'string')) {
      callback = options;
      options = null;
    }
    options = _.extend(DEFAULT_OPTIONS, options || {});
    if (!USE_XHR) {
      options.method = 'GET';
    }
    var use_post = options.method === 'POST';
    var use_sendBeacon = sendBeacon && use_post && options.transport.toLowerCase() === 'sendbeacon';

    // needed to correctly format responses
    var verbose_mode = this.get_config('verbose');
    if (data['verbose']) {
      verbose_mode = true;
    }

    if (this.get_config('test')) {
      data['test'] = 1;
    }
    if (verbose_mode) {
      data['verbose'] = 1;
    }
    if (this.get_config('img')) {
      data['img'] = 1;
    }
    if (!USE_XHR) {
      if (callback) {
        data['callback'] = callback;
      } else if (verbose_mode || this.get_config('test')) {
        // Verbose output (from verbose mode, or an error in test mode) is a json blob,
        // which by itself is not valid javascript. Without a callback, this verbose output will
        // cause an error when returned via jsonp, so we force a no-op callback param.
        // See the ECMA script spec: http://www.ecma-international.org/ecma-262/5.1/#sec-12.4
        data['callback'] = '(function(){})';
      }
    }

    data['ip'] = this.get_config('ip') ? 1 : 0;
    data['_'] = new Date().getTime().toString();

    if (use_post) {
      body_data = `[${data['json_data']}]`;
      delete data['data'];
    }
    try {
      windowConsole.debug &&
        windowConsole.debug(
          `Alooma source: client ${PRIMARY_INSTANCE_NAME} sending request with data`,
          JSON.parse(data['json_data'])
        );
    } catch (e) {}
    delete data['json_data'];

    url += '?' + _.HTTPBuildQuery(data);

    if ('img' in data) {
      var img = document.createElement('img');
      img.src = url;
      document.body.appendChild(img);
    } else if (use_sendBeacon) {
      try {
        sendBeacon(url, body_data);
      } catch (e) {
        console.error(e);
      }
    } else if (USE_XHR) {
      try {
        var req = new XMLHttpRequest();
        req.open(options.method, url, true);

        var headers = this.get_config('xhr_headers');
        if (use_post) {
          headers['Content-Type'] = 'application/json';
        }
        _.each(headers, function (headerValue, headerName) {
          req.setRequestHeader(headerName, headerValue);
        });

        // send the mp_optout cookie
        // withCredentials cannot be modified until after calling .open on Android and Mobile Safari
        req.withCredentials = true;
        req.onreadystatechange = function () {
          if (req.readyState === 4) {
            // XMLHttpRequest.DONE == 4, except in safari 4
            if (req.status === 200) {
              if (callback) {
                if (verbose_mode) {
                  var response;
                  try {
                    response = _.JSONDecode(req.responseText);
                  } catch (e) {
                    console.error(e);
                    return;
                  }
                  callback(response);
                } else {
                  callback(Number(req.responseText));
                }
              }
            } else {
              var error = 'Bad HTTP status: ' + req.status + ' ' + req.statusText;
              console.error(error);
              if (callback) {
                if (verbose_mode) {
                  callback({ status: 0, error: error });
                } else {
                  callback(0);
                }
              }
            }
          }
        };
        req.send(body_data);
      } catch (e) {
        console.error(e);
      }
    } else {
      var script = document.createElement('script');
      script.type = 'text/javascript';
      script.async = true;
      script.defer = true;
      script.src = url;
      var s = document.getElementsByTagName('script')[0];
      s.parentNode.insertBefore(script, s);
    }
  };

  /**
   * _execute_array() deals with processing any alooma function
   * calls that were called before the Alooma library were loaded
   * (and are thus stored in an array so they can be called later)
   *
   * Note: we fire off all the alooma function calls && user defined
   * functions BEFORE we fire off alooma tracking calls. This is so
   * identify/register/set_config calls can properly modify early
   * tracking calls.
   *
   * @param {Array} array
   */
  AloomaLib.prototype._execute_array = function (array) {
    let fn_name;
    const alias_calls = [];
    const other_calls = [];
    const tracking_calls = [];
    _.each(
      array,
      function (item) {
        if (item) {
          fn_name = item[0];
          if (typeof item === 'function') {
            item.call(this);
          } else if (_.isArray(item) && fn_name === 'alias') {
            alias_calls.push(item);
          } else if (
            _.isArray(item) &&
            fn_name.indexOf('track') != -1 &&
            typeof this[fn_name] === 'function'
          ) {
            tracking_calls.push(item);
          } else {
            other_calls.push(item);
          }
        }
      },
      this
    );

    const execute = function (calls, context) {
      _.each(
        calls,
        function (item) {
          this[item[0]].apply(this, item.slice(1));
        },
        context
      );
    };

    execute(alias_calls, this);
    execute(other_calls, this);
    execute(tracking_calls, this);
  };

  AloomaLib.prototype.execute_preload_calls = function (preloadCalls) {
    this._execute_array(preloadCalls);
  }

  /**
   * push() keeps the standard async-array-push
   * behavior around after the lib is loaded.
   * This is only useful for external integrations that
   * do not wish to rely on our convenience methods
   * (created in the snippet).
   *
   * ### Usage:
   *     alooma.push(['register', { a: 'b' }]);
   *
   * @param {Array} item A [function_name, args...] array to be executed
   */
  AloomaLib.prototype.push = function (item) {
    this._execute_array([item]);
  };

  /**
   * Disable events on the Alooma object. If passed no arguments,
   * this function disables tracking of any event. If passed an
   * array of event names, those events will be disabled, but other
   * events will continue to be tracked.
   *
   * Note: this function does not stop other alooma functions from
   * firing, such as register() or people.set().
   *
   * @param {Array} [events] An array of event names to disable
   */
  AloomaLib.prototype.disable = function (events) {
    if (typeof events === 'undefined') {
      this._flags.disable_all_events = true;
    } else {
      this.__disabled_events = this.__disabled_events.concat(events);
    }
  };

  /**
   * Track an event. This is the most important and
   * frequently used Alooma function.
   *
   * ### Usage:
   *
   *     // track an event named "Registered"
   *     alooma.track("Registered", {"Gender": "Male", "Age": 21});
   *
   * To track link clicks or form submissions, see track_links() or track_forms().
   *
   * @param {String} event_name The name of the event. This can be anything the user does - "Button Click", "Sign Up", "Item Purchased", etc.
   * @param {Object} [properties] A set of properties to include with the event you're sending. These describe the user who did the event or details about the event itself.
   * @param {Function} [callback] If provided, the callback function will be called after tracking the event.
   */
  AloomaLib.prototype.track = function (event_name, properties, callback) {
    if (_.isUndefined(event_name)) {
      console.error('No event name provided to alooma.track');
      return;
    }

    if (this._event_is_disabled(event_name)) {
      if (typeof callback !== 'undefined') {
        callback(0);
      }
      return;
    }

    // set defaults
    properties = properties || {};
    properties.token = this.get_config('token');

    // set $duration if time_event was previously called for this event
    const start_timestamp = this.persistence.remove_event_timer(event_name);
    if (!_.isUndefined(start_timestamp)) {
      const duration_in_ms = new Date().getTime() - start_timestamp;
      properties.$duration = parseFloat((duration_in_ms / 1000).toFixed(3));
    }

    // update persistence
    this.persistence.update_search_keyword(document.referrer);

    if (this.get_config('store_google')) {
      this.persistence.update_campaign_params();
    }
    if (this.get_config('save_referrer')) {
      this.persistence.update_referrer_info(document.referrer);
    }

    // note: extend writes to the first object, so lets make sure we
    // don't write to the persistence properties object and info
    // properties object by passing in a new object

    // update properties with pageview info and super-properties
    properties = _.extend({}, _.info.properties(), this.persistence.properties(), properties);

    const property_blacklist = this.get_config('property_blacklist');
    if (_.isArray(property_blacklist)) {
      _.each(property_blacklist, function (blacklisted_prop) {
        delete properties[blacklisted_prop];
      });
    } else {
      console.error(`Invalid value for property_blacklist config: ${property_blacklist}`);
    }

    const data = {
      event: event_name,
      properties,
    };

    const truncated_data = _.truncate(data, this.get_config('truncate'));
    const json_data = _.JSONEncode(truncated_data);
    const encoded_data = _.base64Encode(json_data);

    console.log('ALOOMA REQUEST:');
    console.log(truncated_data);

    this._send_request(
      `${this.get_config('api_host')}/track/`,
      { data: encoded_data, json_data },
      this._prepare_callback(callback, truncated_data)
    );

    return truncated_data;
  };

  /**
   * Track a custom event.
   *
   * ### Usage:
   *
   *     // track a custom event {"artist": "Carla Bruni", "song": "J'arrive Ã  toi"}
   *     alooma.track({"artist": "Carla Bruni", "song": "J'arrive Ã  toi"});
   *
   * To track link clicks or form submissions, see track_links() or track_forms().
   *
   * @param {Object} [event_object] The custom event you're sending.
   * @param {Function} [callback] If provided, the callback function will be called after tracking the event.
   */
  AloomaLib.prototype.track_custom_event = function (event_object, callback) {
    // set defaults
    let properties = {};
    if (event_object) {
      properties = event_object.properties || {};
    }
    properties.token = this.get_config('token');

    // update persistence
    this.persistence.update_search_keyword(document.referrer);

    if (this.get_config('store_google')) {
      this.persistence.update_campaign_params();
    }
    if (this.get_config('save_referrer')) {
      this.persistence.update_referrer_info(document.referrer);
    }

    // note: extend writes to the first object, so lets make sure we
    // don't write to the persistence properties object and info
    // properties object by passing in a new object

    // update properties with pageview info and super-properties

    properties = _.extend({}, _.info.properties(), this.persistence.properties(), properties);

    const property_blacklist = this.get_config('property_blacklist');
    if (_.isArray(property_blacklist)) {
      _.each(property_blacklist, function (blacklisted_prop) {
        delete properties[blacklisted_prop];
      });
    } else {
      console.error(`Invalid value for property_blacklist config: ${property_blacklist}`);
    }

    const data = event_object || {};
    data.properties = properties;

    const truncated_data = _.truncate(data, this.get_config('truncate'));
    const json_data = _.JSONEncode(truncated_data);
    const encoded_data = _.base64Encode(json_data);

    console.log('ALOOMA REQUEST:');
    console.log(truncated_data);

    this._send_request(
      `${this.get_config('api_host')}/track/`,
      { data: encoded_data, json_data },
      this._prepare_callback(callback, truncated_data)
    );

    return truncated_data;
  };

  /**
   * Track a page view event, which is currently ignored by the server.
   * This function is called by default on page load unless the
   * track_pageview configuration variable is false.
   *
   * @param {String} [page] The url of the page to record. If you don't include this, it defaults to the current url.
   */
  AloomaLib.prototype.track_pageview = function (page, properties = {}) {
    if (_.isUndefined(page)) {
      page = document.location.href;
    }
    var data = this.track('mp_page_view', { ..._.info.pageviewInfo(page), ...properties });
    return data;
  };

  /**
   * Track clicks on a set of document elements. Selector must be a
   * valid query. Elements must exist on the page at the time track_links is called.
   *
   * ### Usage:
   *
   *     // track click for link id #nav
   *     alooma.track_links("#nav", "Clicked Nav Link");
   *
   * ### Notes:
   *
   * This function will wait up to 300 ms for the Alooma
   * servers to respond. If they have not responded by that time
   * it will head to the link without ensuring that your event
   * has been tracked.  To configure this timeout please see the
   * set_config() documentation below.
   *
   * If you pass a function in as the properties argument, the
   * function will receive the DOMElement that triggered the
   * event as an argument.  You are expected to return an object
   * from the function; any properties defined on this object
   * will be sent to alooma as event properties.
   *
   * @type {Function}
   * @param {String} query A valid DOM query
   * @param {String} event_name The name of the event to track
   * @param {Object|Function} [properties] A properties object or function that returns a dictionary of properties when passed a DOMElement
   */
  AloomaLib.prototype.track_links = function () {
    return this._track_dom.call(this, LinkTracker, arguments);
  };

  /**
   * Track form submissions. Selector must be a valid query.
   *
   * ### Usage:
   *
   *     // track submission for form id "register"
   *     alooma.track_forms("#register", "Created Account");
   *
   * ### Notes:
   *
   * This function will wait up to 300 ms for the alooma
   * servers to respond, if they have not responded by that time
   * it will head to the link without ensuring that your event
   * has been tracked.  To configure this timeout please see the
   * set_config() documentation below.
   *
   * If you pass a function in as the properties argument, the
   * function will receive the DOMElement that triggered the
   * event as an argument.  You are expected to return an object
   * from the function; any properties defined on this object
   * will be sent to alooma as event properties.
   *
   * @type {Function}
   * @param {String} query  A valid DOM query
   * @param {String} event_name The name of the event to track
   * @param {Object|Function} [properties] This can be a set of properties, or a function that returns a set of properties after being passed a DOMElement
   */
  AloomaLib.prototype.track_forms = function () {
    return this._track_dom.call(this, FormTracker, arguments);
  };

  /**
   * Time an event by including the time between this call and a
   * later 'track' call for the same event in the properties sent
   * with the event.
   *
   * ### Usage:
   *
   *     // time an event named "Registered"
   *     alooma.time_event("Registered");
   *     alooma.track("Registered", {"Gender": "Male", "Age": 21});
   *
   * When called for a particular event name, the next track call for that event
   * name will include the elapsed time between the 'time_event' and 'track'
   * calls. This value is stored as seconds in the '$duration' property.
   *
   * @param {String} event_name The name of the event.
   */
  AloomaLib.prototype.time_event = function (event_name) {
    if (_.isUndefined(event_name)) {
      console.error('No event name provided to alooma.time_event');
      return;
    }

    if (this._event_is_disabled(event_name)) {
      return;
    }

    this.persistence.set_event_timer(event_name, new Date().getTime());
  };

  /**
   * Register a set of super properties, which are included with all
   * events. This will overwrite previous super property values.
   *
   * ### Usage:
   *
   *     // register "Gender" as a super property
   *     alooma.register({'Gender': 'Female'});
   *
   *     // register several super properties when a user signs up
   *     alooma.register({
   *         'Email': 'jdoe@example.com',
   *         'Account Type': 'Free'
   *     });
   *
   * @param {Object} properties An associative array of properties to store about the user
   * @param {Number} [days] How many days since the user's last visit to store the super properties
   */
  AloomaLib.prototype.register = function (props, days) {
    this.persistence.register(props, days);
  };

  /**
   * Register a set of super properties only once. This will not
   * overwrite previous super property values, unlike register().
   *
   * ### Usage:
   *
   *     // register a super property for the first time only
   *     alooma.register_once({
   *         'First Login Date': new Date().toISOString()
   *     });
   *
   * ### Notes:
   *
   * If default_value is specified, current super properties
   * with that value will be overwritten.
   *
   * @param {Object} properties An associative array of properties to store about the user
   * @param {*} [default_value] Value to override if already set in super properties (ex: "False") Default: "None"
   * @param {Number} [days] How many days since the users last visit to store the super properties
   */
  AloomaLib.prototype.register_once = function (props, default_value, days) {
    this.persistence.register_once(props, default_value, days);
  };

  /**
   * Delete a super property stored with the current user.
   *
   * @param {String} property The name of the super property to remove
   */
  AloomaLib.prototype.unregister = function (property) {
    this.persistence.unregister(property);
  };

  AloomaLib.prototype._register_single = function (prop, value) {
    const props = {};
    props[prop] = value;
    this.register(props);
  };

  /**
   * Identify a user with a unique ID. All subsequent
   * actions caused by this user will be tied to this unique ID. This
   * property is used to track unique visitors. If the method is
   * never called, then unique visitors will be identified by a UUID
   * generated the first time they visit the site.
   *
   * ### Notes:
   *
   * You can call this function to overwrite a previously set
   * unique ID for the current user. Alooma cannot translate
   * between IDs at this time, so when you change a user's ID
   * they will appear to be a new user.
   *
   * identify() should not be called to link anonymous activity to
   * subsequent activity when a unique ID is first assigned.
   * Use alias() when a unique ID is first assigned (registration), and
   * use identify() to identify the user with that unique ID on an ongoing
   * basis (e.g., each time a user logs in after registering).
   * Do not call identify() at the same time as alias().
   *
   * @param {String} unique_id A string that uniquely identifies a user
   */
  AloomaLib.prototype.identify = function (
    unique_id,
    _set_callback,
    _add_callback,
    _append_callback,
    _set_once_callback,
    _union_callback
  ) {
    // Optional Parameters
    //  _set_callback:function  A callback to be run if and when the People set queue is flushed
    //  _add_callback:function  A callback to be run if and when the People add queue is flushed
    //  _append_callback:function  A callback to be run if and when the People append queue is flushed
    //  _set_once_callback:function  A callback to be run if and when the People set_once queue is flushed
    //  _union_callback:function  A callback to be run if and when the People union queue is flushed

    // identify only changes the distinct id if it doesn't match either the existing or the alias;
    // if it's new, blow away the alias as well.
    if (unique_id != this.get_distinct_id() && unique_id != this.get_property(ALIAS_ID_KEY)) {
      this.unregister(ALIAS_ID_KEY);
      this._register_single('distinct_id', unique_id);
    }
    this._flags.identify_called = true;
  };

  /**
   * Returns the current distinct id of the user. This is either the id automatically
   * generated by the library or the id that has been passed by a call to identify().
   *
   * ### Notes:
   *
   * get_distinct_id() can only be called after the Alooma library has finished loading.
   * init() has a loaded function available to handle this automatically. For example:
   *
   *     // set distinct_id after the alooma library has loaded
   *     alooma.init("YOUR PROJECT TOKEN", {
   *         loaded: function() {
   *             distinct_id = alooma.get_distinct_id();
   *         }
   *     });
   */
  AloomaLib.prototype.get_distinct_id = function () {
    return this.get_property('distinct_id');
  };

  /**
   * Create an alias, which Alooma will use to link two distinct_ids going forward (not retroactively).
   * Multiple aliases can map to the same original ID, but not vice-versa. Aliases can also be chained - the
   * following is a valid scenario:
   *
   *     alooma.alias("new_id", "existing_id");
   *     ...
   *     alooma.alias("newer_id", "new_id");
   *
   * If the original ID is not passed in, we will use the current distinct_id - probably the auto-generated GUID.
   *
   * ### Notes:
   *
   * The best practice is to call alias() when a unique ID is first created for a user
   * (e.g., when a user first registers for an account and provides an email address).
   * alias() should never be called more than once for a given user, except to
   * chain a newer ID to a previously new ID, as described above.
   *
   * @param {String} alias A unique identifier that you want to use for this user in the future.
   * @param {String} [original] The current identifier being used for this user.
   */
  AloomaLib.prototype.alias = function (alias, original) {
    // If the $people_distinct_id key exists in persistence, there has been a previous
    // alooma.people.identify() call made for this user. It is VERY BAD to make an alias with
    // this ID, as it will duplicate users.
    if (alias === this.get_property(PEOPLE_DISTINCT_ID_KEY)) {
      console.critical('Attempting to create alias for existing People user - aborting.');
      return -2;
    }

    const _this = this;
    if (_.isUndefined(original)) {
      original = this.get_distinct_id();
    }
    if (alias !== original) {
      this._register_single(ALIAS_ID_KEY, alias);
      return this.track('$create_alias', { alias, distinct_id: original }, function (response) {
        // Flush the people queue
        _this.identify(alias);
      });
    }
    console.error('alias matches current distinct_id - skipping api call.');
    this.identify(alias);
    return -1;
  };

  /**
   * Provide a string to recognize the user by. The string passed to
   * this method will appear in the Alooma Streams product rather
   * than an automatically generated name. Name tags do not have to
   * be unique.
   *
   * This value will only be included in Streams data.
   *
   * @param {String} name_tag A human readable name for the user
   */
  AloomaLib.prototype.name_tag = function (name_tag) {
    this._register_single('mp_name_tag', name_tag);
  };

  /**
   * Update the configuration of a alooma library instance.
   *
   * The default config is:
   *
   *     {
   *       // super properties cookie expiration (in days)
   *       cookie_expiration:          365
   *
   *       // super properties span subdomains
   *       cross_subdomain_cookie:     true
   *
   *       // if this is true, the alooma cookie or localStorage entry
   *       // will be deleted, and no user persistence will take place
   *       disable_persistence:        false
   *
   *       // type of persistent store for super properties (cookie/
   *       // localStorage) if set to "localStorage", any existing
   *       // alooma cookie value with the same persistence_name
   *       // will be transferred to localStorage and deleted
   *       persistence:                "cookie"
   *
   *       // name for super properties persistent store
   *       persistence_name:           ""
   *
   *       // names of properties/superproperties which should never
   *       // be sent with track() calls
   *       property_blacklist:         []
   *
   *       // if this is true, alooma cookies will be marked as
   *       // secure, meaning they will only be transmitted over https
   *       secure_cookie:              false
   *
   *       // the amount of time track_links will
   *       // wait for Alooma's servers to respond
   *       track_links_timeout:        300
   *
   *       // should we track a page view on page load
   *       track_pageview:             true
   *
   *       // if you set upgrade to be true, the library will check for
   *       // a cookie from our old js library and import super
   *       // properties from it, then the old cookie is deleted
   *       // The upgrade config option only works in the initialization,
   *       // so make sure you set it when you create the library.
   *       upgrade:                    false
   *     }
   *
   *
   * @param {Object} config A dictionary of new configuration values to update
   */
  AloomaLib.prototype.set_config = function (config) {
    if (_.isObject(config)) {
      _.extend(this.config, config);

      if (!this.get_config('persistence_name')) {
        this.config.persistence_name = this.config.cookie_name;
      }
      if (!this.get_config('disable_persistence')) {
        this.config.disable_persistence = this.config.disable_cookie;
      }

      if (this.persistence) {
        this.persistence.update_config(this.config);
      }
      DEBUG = DEBUG || this.get_config('debug');
    }
  };

  /**
   * returns the current config object for the library.
   */
  AloomaLib.prototype.get_config = function (prop_name) {
    return this.config[prop_name];
  };

  /**
   * Returns the value of the super property named property_name. If no such
   * property is set, get_property() will return the undefined value.
   *
   * ### Notes:
   *
   * get_property() can only be called after the Alooma library has finished loading.
   * init() has a loaded function available to handle this automatically. For example:
   *
   *     // grab value for "user_id" after the alooma library has loaded
   *     alooma.init("YOUR PROJECT TOKEN", {
   *         loaded: function() {
   *             user_id = alooma.get_property("user_id");
   *         }
   *     });
   *
   * @param {String} property_name The name of the super property you want to retrieve
   */
  AloomaLib.prototype.get_property = function (property_name) {
    return this.persistence.props[property_name];
  };

  AloomaLib.prototype.toString = function () {
    let name = this.get_config('name');
    if (name !== PRIMARY_INSTANCE_NAME) {
      name = `${PRIMARY_INSTANCE_NAME}.${name}`;
    }
    return name;
  };

  AloomaLib.prototype._event_is_disabled = function (event_name) {
    return (
      _.isBlockedUA(userAgent) ||
      this._flags.disable_all_events ||
      _.include(this.__disabled_events, event_name)
    );
  };

  // EXPORTS (for closure compiler)

  // Underscore Exports
  _.toArray = _.toArray;
  _.isObject = _.isObject;
  _.JSONEncode = _.JSONEncode;
  _.JSONDecode = _.JSONDecode;
  _.isBlockedUA = _.isBlockedUA;
  _.isEmptyObject = _.isEmptyObject;
  _.UUID = _.UUID;
  _.info = _.info;
  _.info.device = _.info.device;
  _.info.browser = _.info.browser;
  _.info.properties = _.info.properties;

  // AloomaLib Exports
  AloomaLib.prototype.init = AloomaLib.prototype.init;
  AloomaLib.prototype.disable = AloomaLib.prototype.disable;
  AloomaLib.prototype.time_event = AloomaLib.prototype.time_event;
  AloomaLib.prototype.track = AloomaLib.prototype.track;
  AloomaLib.prototype.track_custom_event = AloomaLib.prototype.track_custom_event;
  AloomaLib.prototype.track_links = AloomaLib.prototype.track_links;
  AloomaLib.prototype.track_forms = AloomaLib.prototype.track_forms;
  AloomaLib.prototype.track_pageview = AloomaLib.prototype.track_pageview;
  AloomaLib.prototype.register = AloomaLib.prototype.register;
  AloomaLib.prototype.register_once = AloomaLib.prototype.register_once;
  AloomaLib.prototype.unregister = AloomaLib.prototype.unregister;
  AloomaLib.prototype.identify = AloomaLib.prototype.identify;
  AloomaLib.prototype.alias = AloomaLib.prototype.alias;
  AloomaLib.prototype.name_tag = AloomaLib.prototype.name_tag;
  AloomaLib.prototype.set_config = AloomaLib.prototype.set_config;
  AloomaLib.prototype.get_config = AloomaLib.prototype.get_config;
  AloomaLib.prototype.get_property = AloomaLib.prototype.get_property;
  AloomaLib.prototype.get_distinct_id = AloomaLib.prototype.get_distinct_id;
  AloomaLib.prototype.toString = AloomaLib.prototype.toString;

  // AloomaPersistence Exports
  AloomaPersistence.prototype.properties = AloomaPersistence.prototype.properties;
  AloomaPersistence.prototype.update_search_keyword =
    AloomaPersistence.prototype.update_search_keyword;
  AloomaPersistence.prototype.update_referrer_info =
    AloomaPersistence.prototype.update_referrer_info;
  AloomaPersistence.prototype.get_cross_subdomain = AloomaPersistence.prototype.get_cross_subdomain;
  AloomaPersistence.prototype.clear = AloomaPersistence.prototype.clear;

  _.safewrap_class(AloomaLib, ['identify']);

  const instances = {};
  const extend_mp = function () {
    // add all the sub alooma instances
    _.each(instances, function (instance, name) {
      if (name !== PRIMARY_INSTANCE_NAME) {
        alooma_master[name] = instance;
      }
    });

    // add private functions as _
    alooma_master._ = _;
  };

  const override_mp_init_func = function () {
    // we override the snippets init function to handle the case where a
    // user initializes the alooma library after the script loads & runs
    alooma_master.init = function (token, config, name) {
      if (name) {
        // initialize a sub library
        if (!alooma_master[name]) {
          alooma_master[name] = instances[name] = create_mplib(token, config, name);
          alooma_master[name]._loaded();
        }
        return alooma_master[name];
      }
      let instance = alooma_master;

      if (instances[PRIMARY_INSTANCE_NAME]) {
        // main alooma lib already initialized
        instance = instances[PRIMARY_INSTANCE_NAME];
      } else if (token) {
        // intialize the main alooma lib
        instance = create_mplib(token, config, PRIMARY_INSTANCE_NAME);
        instance._loaded();
        instances[PRIMARY_INSTANCE_NAME] = instance;
      }

      alooma_master = instance;
      if (init_type === INIT_SNIPPET) {
        window[PRIMARY_INSTANCE_NAME] = alooma_master;
      }
      extend_mp();
    };
  };

  const add_dom_loaded_handler = function () {
    // Cross browser DOM Loaded support
    function dom_loaded_handler() {
      // function flag since we only want to execute this once
      if (dom_loaded_handler.done) {
        return;
      }
      dom_loaded_handler.done = true;

      DOM_LOADED = true;
      ENQUEUE_REQUESTS = false;

      _.each(instances, function (inst) {
        inst._dom_loaded();
      });
    }

    function do_scroll_check() {
      try {
        document.documentElement.doScroll('left');
      } catch (e) {
        setTimeout(do_scroll_check, 1);
        return;
      }

      dom_loaded_handler();
    }

    if (document.addEventListener) {
      if (document.readyState == 'complete') {
        // safari 4 can fire the DOMContentLoaded event before loading all
        // external JS (including this file). you will see some copypasta
        // on the internet that checks for 'complete' and 'loaded', but
        // 'loaded' is an IE thing
        dom_loaded_handler();
      } else {
        document.addEventListener('DOMContentLoaded', dom_loaded_handler, false);
      }
    } else if (document.attachEvent) {
      // IE
      document.attachEvent('onreadystatechange', dom_loaded_handler);

      // check to make sure we arn't in a frame
      let toplevel = false;
      try {
        toplevel = window.frameElement == null;
      } catch (e) {}

      if (document.documentElement.doScroll && toplevel) {
        do_scroll_check();
      }
    }

    // fallback handler, always will work
    _.register_event(window, 'load', dom_loaded_handler, true);
  };

  function init_from_snippet() {
    init_type = INIT_SNIPPET;
    alooma_master = window[PRIMARY_INSTANCE_NAME];

    // Initialization
    if (_.isUndefined(alooma_master)) {
      // alooma wasn't initialized properly, report error and quit
      console.critical(
        "'alooma' object not initialized. Ensure you are using the latest version of the Alooma JS Library along with the snippet we provide."
      );
      return;
    }
    if (alooma_master.__loaded || (alooma_master.config && alooma_master.persistence)) {
      // lib has already been loaded at least once; we don't want to override the global object this time so bomb early
      console.error('Alooma library has already been downloaded at least once.');
      return;
    }
    const snippet_version = alooma_master.__SV || 0;
    if (snippet_version < 1.1) {
      // alooma wasn't initialized properly, report error and quit
      console.critical(
        "Version mismatch; please ensure you're using the latest version of the Alooma code snippet."
      );
      return;
    }

    // Load instances of the Alooma Library
    _.each(alooma_master._i, function (item) {
      if (item && _.isArray(item)) {
        instances[item[item.length - 1]] = create_mplib.apply(this, item);
      }
    });

    override_mp_init_func();
    alooma_master.init();

    // Fire loaded events after updating the window's alooma object
    _.each(instances, function (instance) {
      instance._loaded();
    });

    add_dom_loaded_handler();
  }

  init_from_snippet();
}
